var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full bg-cover bg-local lg:bg-fixed bg-center relative",style:({ backgroundImage: `url('${this.background}')` })},[(_vm.dimValue > 0)?_c('div',{staticClass:"absolute inset-0 z-10",style:({ opacity: _vm.dimValue, backgroundColor: '#061f3e' })}):_vm._e(),_c('div',{staticClass:"relative z-20"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }